import * as React from 'react';
import { Checkbox, ICheckboxProps, ICheckboxStyles } from 'office-ui-fabric-react/lib/Checkbox';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';

const styles = require('./OptionsCheckbox.scss');

export default function OptionsCheckbox(props: ICheckboxProps) {
    return (
        <Checkbox
            {...props}
            styles={{
                root: mergeStyles(styles.root, (props.styles as ICheckboxStyles)?.root),
                text: (props.styles as ICheckboxStyles)?.text,
            }}
        />
    );
}
